$('.ranking_nav span').click(function(){
  var index=$(this).index()
  $('.ranking_nav span').removeClass('on').eq(index).addClass('on')
  $('.ranking_cent').hide().eq(index).show()
})

$('.prize_nav span').click(function(){
  var index=$(this).index()
  $('.prize_nav span').removeClass('icon-prize_nav_on').eq(index).addClass('icon-prize_nav_on')
  $('.prize_cent').hide().eq(index).show()
})